function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "13d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.218,
    height: 31.072,
    viewBox: "0 0 30.218 31.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184498"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14447",
    d: "M268.217 191.183a4.444 4.444 0 0 0-4.388-3.437 4.567 4.567 0 0 0-2.794.945 7.952 7.952 0 0 0-7.1-4.255 7.822 7.822 0 0 0-7.853 6.65 5.282 5.282 0 0 0-4.235 5.085 5.335 5.335 0 0 0 5.417 5.215h19.383a5.335 5.335 0 0 0 5.417-5.215 5.263 5.263 0 0 0-3.847-4.988z",
    transform: "translate(-241.843 -179.032)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14524",
    d: "M285.556 46.865a5.149 5.149 0 0 1 2.589-.686 5.082 5.082 0 0 1 4.889 3.57 6.019 6.019 0 0 1 .619.266 6.758 6.758 0 1 0-11.353-6.162 8.347 8.347 0 0 1 3.256 3.012z",
    transform: "translate(-265.952 -38.43)",
    style: {
      fill: "#ff8826"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14530",
    d: "m81.443 398.731-.954.256-1.23-.71 1.23-.71.954.256a.188.188 0 0 0 .1-.363l-.593-.159.418-.241a.188.188 0 0 0-.19-.325l-.416.24.158-.591a.188.188 0 0 0-.363-.1l-.256.957-1.23.71v-1.42l.7-.7a.188.188 0 0 0-.266-.266l-.433.433v-.482a.188.188 0 0 0-.376 0V396l-.433-.433a.188.188 0 0 0-.266.266l.7.7v1.42l-1.23-.71-.256-.957a.188.188 0 0 0-.363.1l.158.591-.416-.24a.188.188 0 0 0-.19.325l.418.241-.593.159a.188.188 0 0 0 .1.363l.954-.256 1.23.71-1.23.71-.954-.256a.188.188 0 0 0-.1.363l.593.159-.418.241a.188.188 0 0 0 .19.325l.416-.24-.158.591a.188.188 0 0 0 .363.1l.256-.957 1.23-.71v1.42l-.7.7a.188.188 0 0 0 .266.266l.433-.433v.482a.188.188 0 0 0 .376 0v-.482l.433.433a.188.188 0 0 0 .266-.266l-.7-.7V398.6l1.23.71.256.957a.188.188 0 0 0 .363-.1l-.158-.591.416.24a.188.188 0 0 0 .19-.325l-.418-.241.593-.159a.188.188 0 0 0-.1-.36z",
    transform: "translate(-68.199 -370.397)",
    style: {
      fill: "#283593",
      stroke: "#283593",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14531",
    d: "m113.31 398.731-.954.256-1.23-.71 1.23-.71.954.256a.188.188 0 0 0 .1-.363l-.593-.159.418-.241a.188.188 0 0 0-.19-.325l-.416.24.158-.591a.188.188 0 0 0-.363-.1l-.256.957-1.23.71v-1.42l.7-.7a.188.188 0 0 0-.266-.266l-.433.433v-.482a.188.188 0 0 0-.376 0V396l-.433-.433a.188.188 0 0 0-.266.266l.7.7v1.42l-1.23-.71-.256-.957a.188.188 0 0 0-.363.1l.158.591-.416-.24a.188.188 0 0 0-.19.325l.418.241-.593.159a.188.188 0 0 0 .1.363l.954-.256 1.23.71-1.23.71-.954-.256a.188.188 0 0 0-.1.363l.593.159-.418.241a.188.188 0 0 0 .19.325l.416-.24-.158.591a.188.188 0 0 0 .363.1l.256-.957 1.23-.71v1.42l-.7.7a.188.188 0 0 0 .266.266l.433-.433v.482a.188.188 0 0 0 .376 0v-.482l.433.433a.188.188 0 0 0 .266-.266l-.7-.7V398.6l1.23.71.256.957a.188.188 0 0 0 .363-.1l-.158-.591.416.24a.188.188 0 0 0 .19-.325l-.418-.241.593-.159a.188.188 0 0 0-.1-.36z",
    transform: "translate(-91.566 -370.397)",
    style: {
      fill: "#283593",
      stroke: "#283593",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184501"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14448",
    d: "M266.03 191.266a6.281 6.281 0 0 1 5.088-2.716.376.376 0 0 0 0-.752 7.077 7.077 0 0 0-5.738 3.088c-.279.4.373.774.65.38z",
    transform: "translate(-259.051 -181.497)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184500"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14449",
    d: "M246.365 218.167a4.088 4.088 0 0 1 1.917-3.406c.407-.26.03-.912-.38-.65a4.866 4.866 0 0 0-2.289 4.055.376.376 0 0 0 .752 0z",
    transform: "translate(-244.606 -200.747)",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13D);
export default __webpack_public_path__ + "static/media/13D.5cadf891d38e142e11d255920e9420cb.svg";
export { ForwardRef as ReactComponent };